var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxThree(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2275 9.69C2.00607 9.82304 1.82275 10.011 1.69529 10.2357C1.56783 10.4604 1.50057 10.7142 1.5 10.9725V13.4025C1.50057 13.6608 1.56783 13.9146 1.69529 14.1393C1.82275 14.364 2.00607 14.552 2.2275 14.685L4.4775 16.035C4.7108 16.1752 4.97783 16.2492 5.25 16.2492C5.52217 16.2492 5.7892 16.1752 6.0225 16.035L9 14.25V10.125L5.25 7.875L2.2275 9.69Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25031 12.3719L1.69531 10.2344",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12.375L9 10.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12.375V16.2525",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.125V14.25L11.9775 16.035C12.2108 16.1752 12.4778 16.2492 12.75 16.2492C13.0222 16.2492 13.2892 16.1752 13.5225 16.035L15.7725 14.685C15.9939 14.552 16.1773 14.364 16.3047 14.1393C16.4322 13.9146 16.4994 13.6608 16.5 13.4025V10.9725C16.4994 10.7142 16.4322 10.4604 16.3047 10.2357C16.1773 10.011 15.9939 9.82304 15.7725 9.69L12.75 7.875L9 10.125Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.375L9 10.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.3719L16.305 10.2344",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.375V16.2525",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9775 3.31421C5.75607 3.44725 5.57275 3.63522 5.44529 3.85991C5.31783 4.0846 5.25057 4.33839 5.25 4.59671V7.87421L9 10.1242L12.75 7.87421V4.59671C12.7494 4.33839 12.6822 4.0846 12.5547 3.85991C12.4273 3.63522 12.2439 3.44725 12.0225 3.31421L9.7725 1.96421C9.5392 1.82405 9.27217 1.75 9 1.75C8.72783 1.75 8.4608 1.82405 8.2275 1.96421L5.9775 3.31421Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00031 5.99687L5.44531 3.85938",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.99687L12.555 3.85938",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.125V6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxThree);
export default __webpack_public_path__ + "static/media/BoxThree.530ea2c8b145b80965ef7ff8b7b36413.svg";
export { ForwardRef as ReactComponent };